import OnSiteContactList from './pages/ListPage.vue'
import OnSiteContactDetail from './pages/FormPage.vue'
import OnSiteContactIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/on_site_contact',
    component: OnSiteContactIndex,
    redirect: '/on_site_contact/list',
    name: 'on_site_contact',
    children: [
      {
        path: 'list',
        component: OnSiteContactList,
        name: 'on_site_contact.list'
      },
      {
        path: 'create',
        component: OnSiteContactDetail,
        name: 'on_site_contact.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: OnSiteContactDetail,
        name: 'on_site_contact.edit',
        props: {create: false},
      },
    ],
  },
]
